import 'react-quill/dist/quill.snow.css';

import React, { Suspense } from 'react';

import { Skeleton } from 'antd';

type WysiwygProps = {
  value: string;
  onChange: (v: string) => void;
};

const ReactQuill = React.lazy(() => import('react-quill'));

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
    ['link']
  ]
};

const formats = ['header', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'indent', 'link'];

export const Wysiwyg = ({ value, onChange }: WysiwygProps) => {
  const fmt = value
    ?.replace(/<span style="text-decoration:underline;">/g, '<u>')
    .replace(/<span style="text-decoration:line-through;">/g, '<s>');

  const handleChange = (v: string, _delta: unknown, source: string) => {
    if (source !== 'user') return;
    onChange(v);
  };

  return (
    <Suspense fallback={<Skeleton.Input active style={{ width: '100%', height: 100 }} />}>
      <ReactQuill value={fmt} onChange={handleChange} modules={modules} formats={formats} />
    </Suspense>
  );
};
